import { useState } from 'react'
import { ClientsSearch } from '../../../../../components/ClientsSearch'
import { CreateClient } from '../../../../../components/CreateClient'
import { IsGranted } from '../../../auth'
import { ROLE, useAuth } from '../../../auth'
import '../../../../assets/css/pagination.css'

export const ClientsList = () => {
  const { currentUser } = useAuth()
  const [showCreateModal, setShowCreateModal] = useState(false)

  const canCreateClient = IsGranted([ROLE.ROLE_SENIOR_CASHIER, ROLE.ROLE_ADMIN, ROLE.ROLE_MANAGER], currentUser)

  return (
    <div>
      <div className='card sticky-top-tickets mb-7'>
        <div className='card-header border-0 pt-5 pb-2'>
          <h3 className='card-title align-items-start flex-column'>
            <span className='card-label fw-bold fs-3 mb-1'>Клиенты</span>
          </h3>
          {canCreateClient && (
            <div className='card-toolbar'>
              <button 
                className='btn btn-sm btn-primary'
                onClick={() => setShowCreateModal(true)}
              >
                Создать клиента
              </button>
            </div>
          )}
        </div>
      </div>

      <div className='card'>
        <div className='card-body py-3'>
          <ClientsSearch />
        </div>
      </div>

      {canCreateClient && (
        <CreateClient
          show={showCreateModal}
          onHide={() => setShowCreateModal(false)}
        />
      )}
    </div>
  )
}
